/* eslint-disable max-lines */
/* eslint-disable sonarjs/no-redundant-boolean */
// 9fbef606107a605d69c0edbcd8029e5d
import { formValueSelector, getFormValues, getFormSyncErrors } from 'redux-form';
import { createSelector, defaultMemoize, createSelectorCreator } from 'reselect';
import isEqual from 'lodash/isEqual';
import { List } from 'immutable';
import {
  CHECKOUT_REDUCER_KEY,
  CARTPAGE_REDUCER_KEY,
  SESSIONCONFIG_REDUCER_KEY,
} from '@tcp/core/src/constants/reducer.constants';
import {
  getAPIConfig,
  isSafariBrowser,
  getViewportInfo,
  parseBoolean,
  getABtestFromState,
  isCanada,
  isUsOnly,
  isSafariMobileBrowser,
  isSFCC,
} from '@tcp/core/src/utils';
import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';
import {
  getIsSmsUpdatesEnabled,
  getIsInternationalShipping,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';

/* eslint-disable extra-rules/no-commented-out-code */
import {
  getPersonalDataState,
  getUserName,
  getUserLastName,
  getUserPhoneNumber,
  getUserEmail,
  getplccCardNumber,
  isPlccUser,
  getRewardsState,
} from '../../../account/User/container/User.selectors';
import constants from '../Checkout.constants';
import { getAddressListState } from '../../../account/AddressBook/container/AddressBook.selectors';
import {
  getGiftServicesFormData,
  getSyncError,
  getPaypalPaymentSettings,
  getExpressReviewShippingSectionId,
  getDefaultShipmentMethods,
  getIsOptimseUpdateShipment,
  getIsAfterPayInProgress,
  getReviewFormValues,
  getIsAfterPayPaymentProgress,
  getShowCouponsDrawer,
  getIsPaypalPaymentProgress,
} from './Checkout.selector.util';
import {
  getVenmoData,
  getVenmoClientTokenData,
  isVenmoPaymentInProgress,
  isVenmoPickupBannerDisplayed,
  isVenmoShippingBannerDisplayed,
  isVenmoPaymentSaveSelected,
  getVenmoError,
  isVenmoNonceNotExpired,
  isVenmoPaymentToken,
  isVenmoNonceActive,
  isVenmoPaymentAvailable,
  getVenmoUserName,
  getVenmoPayment,
  isVenmoOrderPayment,
  getVenmoOrderUserId,
  isVenmoAppInstalled,
} from './CheckoutVenmo.selector';
import {
  getAppleClientTokenData,
  isApplePaymentInProgress,
  getApplePayAppDataApp,
  getApplePayEligibleShippingState,
  isAppleOrderPayment,
} from './CheckoutApple.selector';
import BagPageSelectors from '../../BagPage/container/BagPage.selectors';
import { ADDRESS_TYPE } from '../../SinglePageCheckout/container/SinglePageCheckout.constants';
import { SHIPPING_FORM_NAME } from '../../SinglePageCheckout/container/Shipping/Shipping.constants';
import { PICKUP_FORM_NAME } from '../../SinglePageCheckout/container/Pickup/Pickup.constants';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

export const getCheckoutState = (state) => {
  return state[CHECKOUT_REDUCER_KEY];
};

export const getCheckoutUiFlagState = (state) => {
  return state[CHECKOUT_REDUCER_KEY].get('uiFlags');
};

export const getCheckoutValuesState = createSelector(
  getCheckoutState,
  (state) => state && state.get('values')
);

const getIsOrderHasShipping = (state) =>
  !!state[CARTPAGE_REDUCER_KEY].getIn(['orderDetails', 'isShippingOrder']);

const getIsOrderHasPickup = (state) =>
  !!state[CARTPAGE_REDUCER_KEY].getIn(['orderDetails', 'isPickupOrder']);

const getIfCheckoutRoutingDone = (state) => {
  return state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'routingDone']);
};

const isExpressAfterPayFlow = (state) => {
  return state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'isExpressAfterPayFlow']);
};
const getIfRedirectFromExpress = (state) => {
  return state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'redirectFromExpress']);
};

const getIfInitCheckoutFinished = (state) => {
  return state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'initCheckoutFinished']);
};

const getCardType = (state) => {
  return state.Checkout.getIn(['values', 'billing', 'billing', 'cardType']);
};

export const isGuest = createSelector(getPersonalDataState, (state) =>
  state == null ? true : !!state.get('isGuest')
);

export const getMprId = createSelector(
  getRewardsState,
  (state) => state && state.get('accountNumber')
);

function getIsMobile() {
  if (typeof window === 'undefined')
    return {
      width: 0,
      height: 0,
      isMobile: false,
      isTablet: false,
      isDesktop: false,
    };
  return getViewportInfo().isMobile;
}

export const isExpressCheckout = createSelector(
  getPersonalDataState,
  (state) => state && state.get('isExpressEligible')
);

export const getCheckoutStage = createSelector(
  getCheckoutUiFlagState,
  (state) => state && state.get('stage')
);

export const isRemembered = createSelector(
  getPersonalDataState,
  (state) => state && state.get('isRemembered')
);

// function getUserContactInfo(state) {
//   return state.User.getIn(['personalData', 'contactInfo']);
// }

export const getUserContactInfo = createSelector(
  getPersonalDataState,
  (state) => state && state.get('contactInfo')
);
export const getShippingValues = (state) => {
  return state?.Checkout.getIn(['values', 'shipping']);
};

export const getIsSubmitOrderError = (state) => {
  return state?.Checkout.getIn(['values', 'isSubmitOrderError']);
};

export const getIsSubmitOrderErrorCode = (state) => {
  return state?.Checkout.getIn(['values', 'isSubmitOrderErrorCode']);
};

export const getPickupValues = createSelector(
  getCheckoutValuesState,
  (state) => state && state.get('pickUpContact')
);

export const isExpressCallDoneThroughPlccIcFailure = createSelector(
  getCheckoutValuesState,
  (state) => state && state.get('isExpressCallDoneThroughPlccIcFailure')
);

const getShippingDestinationValues = createDeepEqualSelector(
  [getShippingValues, getUserEmail, getUserPhoneNumber],
  (shipping, userEmail, phoneNumber) => {
    const { emailAddress, ...result } = JSON.parse(JSON.stringify(shipping));
    // For shipping address when user logged-in, override email address that of user.
    // When user is guest, keep the address he specified in shipping section.
    return {
      emailAddress: userEmail || emailAddress,
      phoneNumber,
      ...result,
    };
  }
);

export const getStoreAddress = (addressObject) => {
  const {
    addressLine1 = '',
    city = '',
    state = '',
    zipCode = '',
    addressLine2 = '',
    country = '',
  } = addressObject || {};
  return {
    addressLine1,
    city,
    state,
    zipCode,
    country,
    addressLine2,
  };
};

const getBossBopisStoreAddress = defaultMemoize((state) => {
  const stores = state.CartPageReducer.getIn(['orderDetails', 'stores']) || 0;
  const isValidStoreType = Array.isArray(stores);
  const firstStore = isValidStoreType && stores[0];
  return getStoreAddress(firstStore?.address);
});

const getBopisValues = createSelector(
  [getBossBopisStoreAddress, getPickupValues],
  (address, pickupValues) => {
    return {
      ...address,
      ...pickupValues,
    };
  }
);
function getSavedShipmentId(state) {
  return state.Checkout.getIn(['values', 'shipping', 'method', 'shippingMethodId']);
}

export function getSmsPhoneCountryCode(state) {
  return state.Checkout.getIn(['values', 'phoneCountryCode']);
}

export function getSmsPhoneCountryCodePickup(state) {
  return state.Checkout.getIn(['values', 'phoneCountryCodePickup']);
}

function getBillingDestinationValues(state) {
  try {
    const billingMap = state.Checkout.getIn(['values', 'billing']);
    return billingMap ? JSON.parse(JSON.stringify(billingMap)) : {};
  } catch (e) {
    console.error('Error in getBillingDestinationValues', e);
    return {};
  }
}

const getShippingAddressID = createSelector(
  getShippingDestinationValues,
  (shippingDestinationValues) => {
    const { onFileAddressId } = shippingDestinationValues;
    return onFileAddressId;
  }
);

const getShippingAddress = createSelector(
  getShippingDestinationValues,
  (shippingDestinationValues) => {
    const { address } = shippingDestinationValues;
    return address;
  }
);

const getBillingAddress = createSelector(
  getBillingDestinationValues,
  (billingDestinationValues) => {
    const { address } = billingDestinationValues;
    return address;
  }
);
export const getbillingToReviewLoaderState = (state) => {
  return state.PageLoader && state.PageLoader.billingToReviewLoader;
};

const getAddEditResponseAddressId = (state) =>
  state.Checkout.getIn(['values', 'addEditResponseAddressId']);

// function getAddressBook(state, country, noBillingAddresses) {
//   let addresses = [];

//   if (!country) {
//     // if (noBillingAddresses) {
//     //   addresses = state.addresses.addressBook.filter(entry => entry.type !== ADDREESS_TYPE.BILLING);
//     // } else {
//     addresses = getAddressListState(state);
//     // }
//   } // else {
//   // let filtered = state.addresses.addressBook.filter(
//   //   entry =>
//   //     entry.address.country === country &&
//   //     (!noBillingAddresses || entry.type !== ADDREESS_TYPE.BILLING)
//   // );
//   // let defaultAddress = filtered.find(addressEntry => addressEntry.isDefault);

//   // // REVIEW: if there's no default for the selected requested country (country filter might leave it out)
//   // // then flag the first one as default. Can't be on the abstractor,
//   // // unless we store different versions of the address book (per country)
//   // // but I'm not sure about location because storeviews trigger on everything and want to avoid unnecesary renders
//   // if (!defaultAddress) {
//   //   addresses = filtered.map((entry, index) => {
//   //     return {
//   //       ...entry,
//   //       isDefault: index === 0,
//   //     };
//   //   });
//   // } else {
//   //   addresses = filtered;
//   // }
//   // }

//   return addresses;
// }

function getDefaultAddress(/* state, country, noBillingAddresses */) {
  return false;
  // const countryFilteredAddresses = getAddressBook(state, country, noBillingAddresses);
  // const defaultAddress = countryFilteredAddresses.find(
  //   addressEntry => addressEntry.get && addressEntry.get('primary')
  // );

  // if (countryFilteredAddresses.length && !defaultAddress) {
  //   return countryFilteredAddresses.get('0');
  // } else {
  //   return defaultAddress;
  // }
}

// function getPickupValues(state) {
//   return state.Checkout.getIn(['values', 'pickUpContact']);
// }

export const getPickupAltValues = createSelector(
  getCheckoutValuesState,
  (state) => state && state.get('pickUpAlternative')
);
// function getPickupAltValues(state) {
//   return state.Checkout.getIn(['values', 'pickUpAlternative']);
// }

function getGiftWrappingValues(state) {
  return state.Checkout.getIn(['values', 'giftWrap']) || '';
}

function getCurrentSiteId() {
  return getAPIConfig().siteId;
}

export function isUsSite() {
  return getCurrentSiteId() === constants.ROUTING_CONST.siteIds.us;
}

function isSmsUpdatesEnabled(state) {
  return isUsSite() && getIsSmsUpdatesEnabled(state);
}

// function getCurrentPickupFormNumber(state) {
//   let phoneNumber = '';

//   try {
//     phoneNumber = state.form.getIn(['checkoutPickup', 'values', 'pickUpContact', 'phoneNumber']);
//   } catch (error) {
//     // Gobble...Gobble.
//   }

//   return phoneNumber;
// }
const getShippingGiftServicesField = (state) => {
  const selector = formValueSelector('checkoutShipping');
  return selector(state, 'giftServices');
};

const getShippingSmsSignUpFields = (state) => {
  const selector = formValueSelector('checkoutShipping');
  return selector(state, 'smsSignUp');
};

const getShipmentMethodsFields = (state) => {
  const selector = formValueSelector('checkoutShipping');
  return selector(state, 'shipmentMethods');
};

const getShippingPickupFields = (state) => {
  const selector = formValueSelector('checkoutPickup');
  return selector(state, 'pickUpContact');
};

const getSelectedShipmentId = createSelector(
  getShipmentMethodsFields,
  (shipmentMethodsFields) => shipmentMethodsFields && shipmentMethodsFields.shippingMethodId
);

const getShippingSendOrderUpdate = createSelector(
  getShippingSmsSignUpFields,
  (smsSignUpFields) => smsSignUpFields && smsSignUpFields.sendOrderUpdate
);

export const getGiftServicesSend = createSelector(
  getShippingGiftServicesField,
  (giftServicesFields) => giftServicesFields && giftServicesFields.sendGiftServices
);

const getSaveToAddressBook = (state) => {
  const selector = formValueSelector('checkoutShipping');
  return selector(state, 'saveToAddressBook');
};

const getOnFileAddressKey = (state) => {
  const selector = formValueSelector('checkoutShipping');
  return selector(state, 'onFileAddressKey');
};

const getAddressFields = (state) => {
  const selector = formValueSelector('checkoutShipping');
  return selector(state, 'address');
};

const getBillingAddressFields = (state) => {
  return state.Checkout.getIn(['values', 'billing', 'address']);
};

const getAddressPhoneNo = createSelector(
  getAddressFields,
  (addressFields) => addressFields && addressFields.phoneNumber
);

const getDefaultShipping = (state) => {
  const selector = formValueSelector('checkoutShipping');
  return selector(state, 'defaultShipping');
};

const getShippingPhoneAndEmail = createSelector(
  getShippingDestinationValues,
  (shippingDestinationValues) => {
    const { phoneNumber, emailAddress } = shippingDestinationValues;
    return { phoneNumber, emailAddress };
  }
);

const getShippingContactInfo = createSelector(
  getShippingDestinationValues,
  (shippingDestinationValues) => {
    const { phoneNumber, emailAddress, vibesSmsPhoneNo, emailSignUp } = shippingDestinationValues;
    return {
      phoneNumber,
      emailAddress,
      smsSignUp: vibesSmsPhoneNo ? { sendOrderUpdate: !!vibesSmsPhoneNo } : undefined,
      emailSignUp: emailSignUp || undefined,
    };
  }
);

const getIsSMSSignUp = createSelector(getShippingDestinationValues, (shippingDestinationValues) => {
  const { vibesSmsPhoneNo } = shippingDestinationValues;
  return {
    smsSignUp: vibesSmsPhoneNo ? { sendOrderUpdate: !!vibesSmsPhoneNo } : undefined,
  };
});

const getCurrentPickupFormNumber = createSelector(
  getShippingPickupFields,
  (pickUpContact) => pickUpContact && pickUpContact.phoneNumber
);

const getSmsSignUpLabels = () => {
  const smsSignupText = getDynamicLabelValues('dynamic.global_d.lbl_smsSignup_smsSignupText');
  const privacyPolicy = getDynamicLabelValues('dynamic.global_d.lbl_smsSignup_privacyPolicy');
  const orderUpdates = getDynamicLabelValues('dynamic.global_d.lbl_smsSignup_orderUpdates');

  return {
    smsSignupText,
    privacyPolicy,
    orderUpdates,
  };
};

const getShipmentMethods = (state) => {
  return state.Checkout.getIn(['options', 'shippingMethods']);
};

const getShipmentLoadingStatus = (state) => {
  return state.Checkout.getIn(['values', 'isShippingFormLoading']);
};

const getDefaultShipmentID = createSelector(
  [getShipmentMethods, getShippingDestinationValues],
  (shipmentMethods, shippingDestinationValues) => {
    let defaultMethod;
    if (shippingDestinationValues && shippingDestinationValues.method) {
      const {
        method: { shippingMethodId },
      } = shippingDestinationValues;
      if (shippingMethodId) {
        const defaultShipment = shipmentMethods.find((method) => method.id === shippingMethodId);
        defaultMethod = defaultShipment && defaultShipment.id;
        if (defaultMethod) {
          return defaultMethod;
        }
      }
    }
    defaultMethod = shipmentMethods.find((method) => method.isDefault === true);
    return (
      (defaultMethod && defaultMethod.id) || (shipmentMethods.length > 0 && shipmentMethods[0].id)
    );
  }
);

const getSavedShippingMethod = createSelector(
  [getShippingDestinationValues],
  (shipping) => shipping?.method
);
const getSavedShippingMethodCode = createSelector(
  [getShippingDestinationValues],
  (shipping) => shipping?.method?.code
);

const getSelectedShippingMethodDetails = createSelector(
  [getDefaultShipmentID, getShipmentMethods],
  (shippingID, method) => {
    const selectedMethod = method.filter((item) => item.id === shippingID);
    return selectedMethod.length > 0 && selectedMethod[0];
  }
);

const getSelectedShippingMethodCode = createSelector(
  [getDefaultShipmentID, getShipmentMethods],
  (shippingID, method) => {
    const selectedMethod = method.filter((item) => item.id === shippingID);
    return selectedMethod.length > 0 && selectedMethod[0].code;
  }
);

const getAlternateFormFields = (state) => {
  const selector = formValueSelector('checkoutPickup');
  return selector(state, 'pickUpAlternate');
};

export const getAlternateFormFieldsExpress = (state) => {
  const selector = formValueSelector('expressReviewPage');
  return selector(state, 'pickUpAlternateExpress');
};

export const isPickupAlt = createSelector(
  getPickupAltValues,
  (pickUpAlternate) => pickUpAlternate && !!pickUpAlternate.firstName
);

export const getAlternateFormUpdate = createSelector(
  getAlternateFormFields,
  (smsSignUpFields) => smsSignUpFields && smsSignUpFields.hasAlternatePickup
);

const getSmsSignUpFields = (state) => {
  const selector = formValueSelector('checkoutPickup');
  return selector(state, 'smsSignUp');
};

export const getSendOrderUpdate = createSelector(
  getSmsSignUpFields,
  (smsSignUpFields) => smsSignUpFields && smsSignUpFields.sendOrderUpdate
);

const getSmsNumberForOrderUpdates = (state) =>
  state.Checkout.getIn(['values', 'smsInfo', 'numberForUpdates']) ||
  state.Checkout.getIn(['values', 'orderUpdateViaMsg']);

function getPickupInitialPickupSectionValues(state) {
  // let userContactInfo = userStoreView.getUserContactInfo(state);
  // values (if any) entered previously in the checkout process,
  // or reported as checkout defaults by backend
  const pickUpAltValues = getPickupAltValues(state);
  const pickupValues = getPickupValues(state);
  const alternativeData = {
    ...{ hasAlternatePickup: isPickupAlt(state) },
    lastName_alt: pickUpAltValues.lastName,
    firstName_alt: pickUpAltValues.firstName,
    emailAddress_alt: pickUpAltValues.emailAddress,
  };
  const { emailSignUpTCP: emailSignUp, emailSignUpGYM } =
    BagPageSelectors.getIfEmailSignUpDone(state);
  return {
    pickUpContact: {
      firstName: pickupValues.firstName || getUserName(state),
      lastName: pickupValues.lastName || getUserLastName(state),
      emailAddress: pickupValues.emailAddress || getUserEmail(state),
      phoneNumber: pickupValues.phoneNumber || getUserPhoneNumber(state),
      phoneCountryCode: pickUpAltValues.phoneCountryCode || '+1',
    },
    smsSignUp: {
      sendOrderUpdate: !!getSmsNumberForOrderUpdates(state),
      phoneNumber: pickupValues.phoneNumber || getUserPhoneNumber(state),
    },
    hasAlternatePickup: isPickupAlt(state),
    pickUpAlternate: isPickupAlt(state) ? alternativeData : {},
    emailSignUp: {
      emailSignUp,
      emailSignUpGYM,
    },
  };
}
export const getSmsInfoValues = createSelector(
  getCheckoutValuesState,
  (state) => state && state.get('smsInfo')
);
function getShippingInitialSectionValues(state) {
  const shippingValues = getSmsInfoValues(state);
  return {
    smsSignUp: {
      sendOrderUpdate: !!getSmsNumberForOrderUpdates(state),
      phoneNumber: shippingValues.numberForUpdates || getUserPhoneNumber(state),
    },
  };
}

/**
 * Get if Pickup has values in the redux state
 * @param {object} state
 * @returns {boolean}
 */
const isPickupHasValues = (state) => {
  const pickupValues = getPickupInitialPickupSectionValues(state);
  return pickupValues && pickupValues.pickUpContact && pickupValues.pickUpContact.firstName;
};

function getIsPaymentDisabled(state) {
  const orderDetails = state?.CartPageReducer?.get('orderDetails');
  if (orderDetails) {
    return orderDetails.get('grandTotal') <= orderDetails.get('giftCardsTotal');
  }
  return false;
}

function getIsCartHaveGiftCards(state) {
  const orderDetails = state.CartPageReducer.get('orderDetails');
  const orderItems = orderDetails && orderDetails.get('orderItems');
  return orderItems && orderItems.size
    ? orderItems.findIndex((item) => item.getIn(['productInfo', 'isGiftCard'])) !== -1
    : false;
}

function getAddressByKey(state, onFileAddressKey) {
  const addressList = getAddressListState(state);
  if (addressList) {
    return addressList.find((address) => address.nickName === onFileAddressKey);
  }
  return false;
}
const emptyObj = {};
const getBillingValues = createSelector(getCheckoutState, (checkoutState) => {
  const billing = checkoutState.getIn(['values', 'billing']);
  // Returning empty object, if `billing` is a Map of empty object
  if (billing.size === 0) {
    return emptyObj;
  }
  return billing;
});

function getDetailedCreditCardById(state, id) {
  return JSON.parse(JSON.stringify(state.PaymentReducer.get('cardList'))).find(
    ({ creditCardId }) => (creditCardId && creditCardId.toString()) === id.toString()
  );
}

function isCardNotUpdated(state, cardId) {
  return getBillingValues(state).onFileCardId === cardId;
}

const getCvvValidationFormData = (state) => {
  return {
    values: getFormValues('checkoutCardCvvValidation')(state),
    syncErrors: getFormSyncErrors('checkoutCardCvvValidation')(state),
  };
};

const getLoggedInUserInfo = createSelector([getUserEmail, getUserPhoneNumber], (email, phone) => {
  return {
    emailAddress: email,
    phoneNumber: phone,
  };
});

const getCurrentOrderId = (state) => {
  let orderId;
  if (isSFCC()) {
    const orderConfirmation = state?.Confirmation?.get('orderConfirmation');
    const orderNoArray = orderConfirmation?.orderNoArray;
    if (orderNoArray && orderNoArray.length === 1) {
      const [orderId1] = orderNoArray;
      if (!Number.isNaN(orderId1)) {
        orderId = orderId1;
      }
    }
  }
  if (!orderId) {
    orderId = state.CartPageReducer.getIn(['orderDetails', 'orderId']);
  }
  return orderId;
};

const getSubOrderId = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'subOrderId']);
};

const getSmsNumberForBillingOrderUpdates = (state) =>
  state.Checkout.getIn(['values', 'smsInfo', 'numberForUpdates']);

const getCurrentCheckoutStage = (state) => state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'stage']);

const getPrevCheckoutStage = (state) => state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'prevStage']);

export const getEditShippingCheckoutStage = (state) =>
  state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'editShipping']);

export const getCouponRemovedFromOrderFlag = (state) =>
  state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'couponRemovedFromOrder']);

const isGiftOptionsEnabled = (state) => {
  return (
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.GIFTOPTION_ENABLED === '1'
  );
};

const getCheckoutServerError = (state) => {
  return state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'checkoutServerError']);
};

const getCheckoutClientError = (state) => {
  return state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'checkoutClientError']);
};

/**
 * This method is used to decide if we need to show review page next based on order conditions.
 */
const hasVenmoReviewPageRedirect = (state) => {
  const isVenmoInProgress = isVenmoPaymentInProgress(state);
  const isVenmoShippingDisplayed = isVenmoShippingBannerDisplayed(state);
  const orderHasShipping = getIsOrderHasShipping(state);
  const orderHasPickup = getIsOrderHasPickup(state);
  const hasPickupValues = isPickupHasValues(state);
  const addressList = getAddressListState(state);
  const hasShippingAddress = addressList && addressList.size > 0;
  let reviewPageRedirect = false;
  if (!isVenmoInProgress || isVenmoShippingDisplayed) {
    return reviewPageRedirect;
  }
  if (orderHasShipping && orderHasPickup) {
    // Mix Cart
    reviewPageRedirect = hasShippingAddress && hasPickupValues;
  } else if (orderHasShipping) {
    // Ship to Home Item
    reviewPageRedirect = hasShippingAddress;
  } else if (orderHasPickup) {
    // Boss Bopis scenario
    reviewPageRedirect = hasPickupValues;
  }
  return reviewPageRedirect;
};

const getGiftWrapOptions = (state) => {
  return state.Checkout.getIn(['options', 'giftWrapOptions']);
};

const getSelectedGiftWrapDetails = (state) => {
  const orderDetails = state.CartPageReducer.get('orderDetails');
  const checkout = orderDetails.get('checkout');
  const giftWrapName = checkout && checkout.getIn(['giftWrap', 'name']);
  const optionId = checkout && checkout.getIn(['giftWrap', 'optionId']);
  const selectedOptionData = getGiftWrapOptions(state);
  if (selectedOptionData.body) {
    const selectedOption = selectedOptionData.body.giftOptions.filter(
      (option) => option.catEntryId === optionId
    );
    if (selectedOption.length === 1) return selectedOption[0];
  }

  return { name: giftWrapName };
};

/**
 * @function getInternationalCheckoutApiUrl
 * @description this selector gives borderFree url for iframe
 */
function getInternationalCheckoutApiUrl() {
  return getAPIConfig().borderFree;
}
/**
 * @function getInternationalCheckoutCommUrl
 * @description this selector gives borderFreeComm url for iframe
 */
function getInternationalCheckoutCommUrl() {
  return getAPIConfig().borderFreeComm;
}

function getInternationalCheckoutPayPalReturnUrl() {
  return getAPIConfig().borderFreePayPalReturn;
}

/**
 *
 * @function getInternationalCheckoutUrl
 * @param {*} state
 * @description this selector gives international url from state.
 */
function getInternationalCheckoutUrl(state) {
  return state.Checkout.getIn(['options', 'internationalUrl']);
}

/**
 * @function getIsVenmoEnabled
 * @description - Venmo Kill Switch Selector
 * @param {object} state
 * @returns {bool}
 */
const getIsVenmoEnabled = (state) => {
  // Kill switch for mobile web, also checking if on mobile web viewport
  return (
    getIsMobile() &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.VENMO_ENABLED) &&
    isUsOnly()
  );
};

/**
 * @function isApplePayEnabledInXapp
 * @description - Apple pay xapp config selector
 * @param {object} state
 * @returns {bool}
 */
export const isApplePayEnabledInXapp = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.APPLE_PAY_PAYMENT_ENABLED)
  );
};

export const getLoginV2FlowEnabled = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.isLoginV2FlowEnabled) &&
    !(getAbtests && getAbtests.isBackAbTestContactForm)
  );
};

export const getLoginV2FlowEnabledInApp = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_LOGIN_V2_ENABLED_APP) &&
    !(getAbtests && getAbtests.isBackAbTestContactForm)
  );
};

/**
 * @function eligibilityForApplePay
 * @description - Apple pay rendering eligibility based on device and xapp config
 * @param {object} state
 * @returns {bool}
 */
export const eligibilityForApplePay = (state) =>
  (isSafariBrowser() || (isSafariMobileBrowser && isSafariMobileBrowser())) &&
  isApplePayEnabledInXapp(state);

/**
 * @function getIsApplePayEnabled
 * @description - Apple Kill Switch Selector
 * @param {object} state
 * @returns {bool}
 */
export const getIsApplePayEnabled = (state) => {
  if (isCanada() || getIsInternationalShipping(state)) return false;

  if (eligibilityForApplePay(state)) {
    return parseBoolean(getAPIConfig().enableApplePay);
  }
  return false;
};

const getApplePayEnabledWithCard = (state) =>
  state &&
  state[SESSIONCONFIG_REDUCER_KEY] &&
  parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.APPLE_PAY_WITH_CARD_ENABLED);

/**
 * @function getIsApplePayRememberedUser
 * @description - Apple Kill Switch for Remembered User Selector
 * @param {object} state
 * @returns {bool}
 */
const getIsApplePayRememberedUser = (state) => {
  // Kill switch Handling for apple pay remembered user
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.APPLE_PAY_ENABLED_REMEMBERED_USER)
  );
};

const getIsAppleSBPReDesignEnabled = (state) => {
  // Kill switch Handling for SBP Overlay Redesign
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.ENABLE_SBP_OVERLAY_REDESIGN)
  );
};
/**
 * @function getIsApplePayEnabledOnBilling
 * @description - Apple Kill Switch Selector
 * @param {object} state
 * @returns {bool}
 */
const getIsApplePayEnabledOnBilling = (state) => {
  if (eligibilityForApplePay(state)) {
    return parseBoolean(getAPIConfig().enableApplePayOnBilling);
  }

  return false;
};

const getCurrentLanguage = (state) => {
  return (
    (state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.language) ||
    constants.DEFAULT_LANGUAGE
  );
};

const getPayPalSettings = (state) => {
  return state.Checkout.getIn(['options', 'paypalPaymentSettings']) || null;
};

const getShippingAddressList = createSelector(
  [getAddressListState, getCurrentSiteId],
  (userAddresses, country) => {
    let addresses = List();
    const countryName = (country && country.toUpperCase()) || 'US';
    if (userAddresses && userAddresses.size > 0) {
      addresses = userAddresses.filter(
        (address) =>
          address.countryCode === countryName &&
          address.c_addressType &&
          address.c_addressType?.toLowerCase()?.includes(ADDRESS_TYPE.SHIPPING)
      );
      if (addresses.size) {
        return addresses;
      }
    }
    return addresses;
  }
);

const getShippingPhoneNo = (state) => {
  const shippingFormNumber = getAddressPhoneNo(state);
  const addressList = getShippingAddressList(state);
  const selectedAddressKey = getOnFileAddressKey(state);
  const selectedAddress = addressList.filter((address) => {
    return address.addressId === selectedAddressKey;
  });
  const selectedAddressPhoneNo =
    selectedAddress && selectedAddress.size > 0 && selectedAddress.getIn(['0', 'phone1']);
  const { phoneNumber } = getShippingPhoneAndEmail(state);
  return selectedAddressPhoneNo || shippingFormNumber || phoneNumber;
};

const getIsBillingVisited = createSelector(getCheckoutUiFlagState, (uiFlags) => {
  return uiFlags && uiFlags.get('isBillingVisited');
});

const isCheckoutFocused = createSelector(getCheckoutUiFlagState, (uiFlags) => {
  return uiFlags && uiFlags.get('checkoutPageFocus');
});

export const getAppleLoderState = createSelector(getCheckoutUiFlagState, (uiFlags) => {
  return uiFlags && uiFlags.get('appleLoaderState');
});

function getVenmoUserEmail(state) {
  const { emailAddress: shippingEmail } = getShippingPhoneAndEmail(state);
  const { emailAddress: pickupEmail } = getPickupValues(state);
  return getUserEmail(state) || shippingEmail || pickupEmail;
}

function getUserEmailForShipping(state) {
  const { emailAddress: shippingEmail } = getShippingPhoneAndEmail(state);
  return getUserEmail(state) || shippingEmail;
}

const getIsRtpsFlow = createSelector(
  getCheckoutUiFlagState,
  (uiFlags) => uiFlags && uiFlags.get('isRTPSFlow')
);

const getIsRTPSEnabled = (state) =>
  state[SESSIONCONFIG_REDUCER_KEY] &&
  parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.ADS_OLPS_ENABLED);

const hasPLCCOrRTPSEnabled = createSelector(
  [getplccCardNumber, getIsRTPSEnabled, isPlccUser],
  (plccCardNumber, isRTPSEnabled, isPLCCUser) => {
    const hasPLCC = isPLCCUser || plccCardNumber;
    return !hasPLCC && isRTPSEnabled;
  }
);

const getShowRTPSOnBilling = createSelector(
  [getIsOrderHasShipping, getIsOrderHasPickup, getGiftWrappingValues, hasPLCCOrRTPSEnabled],
  (isOrderHasShipping, isOrderHasPickup, giftWrappingValues, rtpsEnabled) => {
    const { hasGiftWrapping } = giftWrappingValues;
    return (isOrderHasShipping || isOrderHasPickup) && !hasGiftWrapping && rtpsEnabled;
  }
);

const getshowRTPSOnReview = createSelector(hasPLCCOrRTPSEnabled, (rtpsEnabled) => {
  return rtpsEnabled;
});

export const getApprovedPLCCCardNumber = createSelector(
  (state) => state.ApplyCardPage,
  (appliedCardPage) => appliedCardPage?.approvedPLCCData?.cardNumber
);

export const getPageData = (state) => {
  return state.pageData;
};

export const getMaxGiftCards = (state) => {
  return (
    state.session && state.session.siteDetails && (state.session.siteDetails.MAX_GIFTCARD || 5)
  );
};

export const isSfsInvMessagingEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.SFS_INVENTORY_CHECK_FOR_DELIVERY_ENABLED)
  );
};

export const getIsOptimiseBillingInfoEnabled = (state) =>
  state[SESSIONCONFIG_REDUCER_KEY] &&
  state[SESSIONCONFIG_REDUCER_KEY].siteDetails.OPTIMISE_BILLING_INFORMATION_ENABLED === '1';

/**
 * @description - validate if gift services option is selected or change, and based on that set recalculate flag.
 * @param {object} state
 */
const getRecalcValueFromGiftServices = (state) => {
  const giftServicesFormData = getGiftServicesFormData(state);
  const giftWrappingValues = getGiftWrappingValues(state);
  let recalc = false;
  const initialGiftWrappingVal = giftWrappingValues.hasGiftWrapping;
  const giftWrappingStoreOptionID = giftWrappingValues.optionId;
  // // If the giftwrapping option differs from the initial state
  // // Recalculate true needs to be sent as true
  if (
    initialGiftWrappingVal !== giftServicesFormData.hasGiftWrapping ||
    (giftWrappingStoreOptionID && giftServicesFormData.catEntryId !== giftWrappingStoreOptionID)
  ) {
    recalc = true;
  }
  return recalc;
};

const getSMSOrderUpdatesId = () => {
  let smsOrderUpdatesID;
  const dynamicsmsSignupLabels = getDynamicLabelValues('global.smsSignup.referred');
  if (dynamicsmsSignupLabels && Array.isArray(dynamicsmsSignupLabels)) {
    smsOrderUpdatesID =
      dynamicsmsSignupLabels.length &&
      dynamicsmsSignupLabels.find((label) => label.name === 'sms_text_terms');
  }
  return smsOrderUpdatesID;
};

const getSMSOrderUpdatesRichTextSelector = (state) => {
  const rContent = state.CartPageReducer.get('moduleXContent').find(
    (moduleX) => moduleX.name === (getSMSOrderUpdatesId() && getSMSOrderUpdatesId().name)
  );
  return rContent && rContent.richText;
};

const getSubmitOrderContentId = () => {
  let submitOrderContentID;
  const dynamicReviewLabels = getDynamicLabelValues('checkout.review');
  if (dynamicReviewLabels && Array.isArray(dynamicReviewLabels.referred)) {
    submitOrderContentID =
      dynamicReviewLabels.referred.length &&
      dynamicReviewLabels.referred.find((label) => label.name === 'submit_order_policy');
  }
  return submitOrderContentID;
};

const getSubmitOrderRichTextSelector = (state) => {
  const rContent = state.CartPageReducer.get('moduleXContent').find(
    (moduleX) => moduleX.name === (getSubmitOrderContentId() && getSubmitOrderContentId().name)
  );
  return rContent && rContent.richText;
};

const getEmailSignUpCaId = () => {
  let emailSignUpCaId;
  const dynamicShippingabels = getDynamicLabelValues('checkout.shipping');
  if (dynamicShippingabels && Array.isArray(dynamicShippingabels.referred)) {
    emailSignUpCaId = dynamicShippingabels.referred.find(
      (label) => label.name.toLowerCase() === 'email_sign_up_ca'
    );
  }
  return emailSignUpCaId;
};

const getEmailSignUpCaRichTextSelector = (state) => {
  const rContent = state.CartPageReducer.get('moduleXContent').find(
    (moduleX) => moduleX.name === (getEmailSignUpCaId() && getEmailSignUpCaId().name)
  );
  return rContent && rContent.richText;
};

export const getABTestForZipCode = ({ AbTest }) => {
  const AbTests = getABtestFromState(AbTest);
  return AbTests && AbTests.zipCodeABTestEnabled;
};

export const getZipCodeLoader = ({ Checkout }) => {
  return Checkout && Checkout.getIn(['shipping', 'zipCodeLoader']);
};

const getSaveCardDefaultChecked = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.SAVE_CARD_DEFAULT_CHECKED)
  );
};

const getSaveCardToAccountUserChoice = (state) => {
  return state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'saveCardToAccountUserChoice']);
};

const getIsSaveCardDefaultChecked = createSelector(
  [getSaveCardDefaultChecked, getSaveCardToAccountUserChoice],
  (saveCardDefaultCheckedValue, saveCardToAccountUserChoice) => {
    let shouldCardAddCheck = saveCardDefaultCheckedValue;
    if (saveCardToAccountUserChoice === constants.SAVE_CARD_CHOICE_VALUES.SAVE) {
      shouldCardAddCheck = true;
    } else if (saveCardToAccountUserChoice === constants.SAVE_CARD_CHOICE_VALUES.DO_NOT_SAVE) {
      shouldCardAddCheck = false;
    }
    return shouldCardAddCheck;
  }
);

const getIsPayPalSelected = createSelector(getBillingValues, (billingValues) => {
  const { paymentMethod } = billingValues;

  return paymentMethod === constants.PAY_PAL;
});

export const getIsPaySecureFailed = createSelector(getBillingValues, (billingValues = {}) => {
  const { billing: { isPaySecureFailed = false } = {} } = billingValues;

  return isPaySecureFailed;
});

export const getShippingLoaderState = (state) => {
  return state.PageLoader && state.PageLoader.shippingLoader;
};

export const getShowRecaptcha = createSelector(
  getCheckoutState,
  (resp) => resp && resp.get('recaptcha')
);

const getShippingReduxFormValues = (state) => state.form?.[SHIPPING_FORM_NAME];
const getPickupReduxFormValues = (state) => state.form?.[PICKUP_FORM_NAME];

export default {
  getIsOrderHasShipping,
  getShippingDestinationValues,
  getBossBopisStoreAddress,
  getBopisValues,
  getDefaultAddress,
  isGuest,
  getIsMobile,
  getPickupInitialPickupSectionValues,
  isSmsUpdatesEnabled,
  getCurrentPickupFormNumber,
  isUsSite,
  getUserContactInfo,
  getPickupAltValues,
  getCurrentSiteId,
  getIsSmsUpdatesEnabled,
  getSmsSignUpFields,
  getShipmentMethodsFields,
  getSelectedShipmentId,
  getSendOrderUpdate,
  getAddressFields,
  getBillingAddressFields,
  getAddressPhoneNo,
  getSmsSignUpLabels,
  getIsOrderHasPickup,
  getGiftWrappingValues,
  getSmsNumberForOrderUpdates,
  getShipmentMethods,
  getDefaultShipmentID,
  getShippingSendOrderUpdate,
  getAlternateFormUpdate,
  getUserEmail,
  getSaveToAddressBook,
  getOnFileAddressKey,
  getShippingSmsSignUpFields,
  getShippingAddressID,
  getDefaultShipping,
  getAddEditResponseAddressId,
  getMprId,
  getShippingAddress,
  getIsPaymentDisabled,
  getShipmentLoadingStatus,
  getBillingValues,
  getAddressByKey,
  isCardNotUpdated,
  getDetailedCreditCardById,
  getSyncError,
  getGiftServicesFormData,
  getGiftServicesSend,
  isGiftOptionsEnabled,
  getPaypalPaymentSettings,
  getSelectedGiftWrapDetails,
  getSelectedShippingMethodDetails,
  getSavedShippingMethod,
  getCurrentOrderId,
  getSubOrderId,
  getSmsNumberForBillingOrderUpdates,
  getVenmoData,
  getVenmoClientTokenData,
  getAppleClientTokenData,
  getApplePayEligibleShippingState,
  isAppleOrderPayment,
  isVenmoPaymentAvailable,
  isVenmoNonceActive,
  isVenmoNonceNotExpired,
  isVenmoPaymentInProgress,
  isApplePaymentInProgress,
  isVenmoPaymentToken,
  getInternationalCheckoutCommUrl,
  getInternationalCheckoutApiUrl,
  getInternationalCheckoutUrl,
  getIsVenmoEnabled,
  getIsApplePayEnabled,
  getIsApplePayEnabledOnBilling,
  getIsApplePayRememberedUser,
  getIsAppleSBPReDesignEnabled,
  getPayPalSettings,
  getCurrentLanguage,
  isVenmoShippingBannerDisplayed,
  isVenmoPickupBannerDisplayed,
  isVenmoPaymentSaveSelected,
  hasVenmoReviewPageRedirect,
  getShippingPhoneAndEmail,
  getShippingContactInfo,
  isPickupHasValues,
  getVenmoUserName,
  getCheckoutServerError,
  getCheckoutClientError,
  getCurrentCheckoutStage,
  getExpressReviewShippingSectionId,
  getPrevCheckoutStage,
  getShippingAddressList,
  getIsBillingVisited,
  getIsRtpsFlow,
  getVenmoUserEmail,
  getUserEmailForShipping,
  getVenmoError,
  getPickupValues,
  getCardType,
  getShippingPhoneNo,
  getIsRTPSEnabled,
  getIfCheckoutRoutingDone,
  getIfRedirectFromExpress,
  getIfInitCheckoutFinished,
  getShowRTPSOnBilling,
  getshowRTPSOnReview,
  getVenmoPayment,
  isVenmoOrderPayment,
  getVenmoOrderUserId,
  getShippingInitialSectionValues,
  isVenmoAppInstalled,
  getDefaultShipmentMethods,
  getIsOptimseUpdateShipment,
  getIsAfterPayInProgress,
  getReviewFormValues,
  getRecalcValueFromGiftServices,
  getSMSOrderUpdatesRichTextSelector,
  getSMSOrderUpdatesId,
  getSubmitOrderContentId,
  getSubmitOrderRichTextSelector,
  getEmailSignUpCaId,
  getEmailSignUpCaRichTextSelector,
  isCheckoutFocused,
  getSelectedShippingMethodCode,
  getApplePayAppDataApp,
  isSfsInvMessagingEnabled,
  getIsSaveCardDefaultChecked,
  getApplePayEnabledWithCard,
  getSaveCardToAccountUserChoice,
  getBillingAddress,
  getIsCartHaveGiftCards,
  getIsPayPalSelected,
  getSavedShipmentId,
  getInternationalCheckoutPayPalReturnUrl,
  getShippingValues,
  getShowRecaptcha,
  getIsSubmitOrderError,
  getSavedShippingMethodCode,
  getIsAfterPayPaymentProgress,
  getIsPaypalPaymentProgress,
  getShowCouponsDrawer,
  isExpressAfterPayFlow,
  getCvvValidationFormData,
  getLoggedInUserInfo,
  getShippingReduxFormValues,
  getPickupReduxFormValues,
  getIsSMSSignUp,
};
